<div class="modal-header"><h2 class="modal-title">Packing Slip</h2></div>
<div class="modal-body" (keyup.esc)="close()">
    <dx-form *ngIf="packingSlip" [formData]="packingSlip" validationGroup="mainValidationGroup">
        <dxi-item itemType="group">
            <dxi-item dataField="packingSlipNumber" [label]="{ text: 'Slip #' }" editorType="dxNumberBox" [disabled]="mode !== 'edit' || disableSlipNumber">
                <dxi-validation-rule type="required" message="Slip Number Required"> </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="createDate" editorType="dxDateBox" [label]="{ text: 'Date' }" [disabled]="mode !== 'edit'"></dxi-item>

            <dxi-item [label]="{ text: 'Delivery Method' }" *ngIf="packingSlip">
                <div *dxTemplate>
                    <dx-select-box
                        [(value)]="packingSlip.deliveryMethod"
                        [items]="deliveryMethods"
                        valueExpr="name"
                        displayExpr="name"
                        [disabled]="mode !== 'edit'"
                        searchEnabled="true"
                        searchMode="startswith"
                        (onValueChanged)="deliverySelectionChanged($event)"
                    >
                    </dx-select-box>
                </div>
                <dxi-validation-rule type="required" [message]="'Dealer Required'"></dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="freight" [label]="{ text: 'Freight' }" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 }, step: 0, disabled: mode !== 'edit' } ">
                <dxi-validation-rule type="required" message="Freight Required"> </dxi-validation-rule>
                <dxi-validation-rule type="numeric" message="Needs to be a number"> </dxi-validation-rule>
                <dxi-validation-rule type="range" min="0.00" message="Cannot be less than 0.00"> </dxi-validation-rule>
            </dxi-item>
            <dxi-item [label]="{ text: 'Shipping Notes' }">
                <div *dxTemplate>
                    <dx-text-area [(value)]="packingSlip.note" [height]="100"> </dx-text-area>
                </div>
            </dxi-item>
        </dxi-item>

        <dxi-item *ngIf="order" itemType="group" caption="Order Information (for reference)">
            <dxi-item [label]="{ text: 'Delivery Method' }">
                <div *dxTemplate>
                    <dx-text-box [value]="order?.deliveryOption?.name" [disabled]="true"> </dx-text-box>
                </div>
            </dxi-item>
            <dxi-item *ngIf="order.allowFreightEntry" [label]="{ text: 'Order Freight' }">
                <div *dxTemplate>
                    <dx-number-box [value]="order?.freight" [disabled]="true" [format]="{ type: 'currency', precision: 2 }"> </dx-number-box>
                </div>
            </dxi-item>
            <dxi-item *ngIf="!order.allowFreightEntry" [label]="{ text: 'Order Freight' }">
                <div *dxTemplate>
                    <dx-text-box [value]="order?.freightDisplay" [disabled]="true" [format]="'#,###.00'" > </dx-text-box>
                </div>
            </dxi-item>
            <dxi-item *ngIf="!order.allowFreightEntry" [label]="{ text: 'Estimated Freight' }">
                <div *dxTemplate>
                    <dx-number-box [value]="calculatedFreight" [disabled]="true" [format]="{ type: 'currency', precision: 2 }"> </dx-number-box>
                </div>
            </dxi-item>
        </dxi-item>
    </dx-form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
</div>
